import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { Layout } from 'antd';

import CabinetHeader from '../../../../components/Header';
import { Helmet } from '../../../../components/Helmet';

import { setIframeQuery } from '../../../../helpers/iframe';

import { PROFILE_DEPOSIT_PATH } from '../../../../constants/profile';
import { DEPOSIT_PATH } from '../../../../constants/routes';
import { useTheme } from '../../../../context/Theme';

import { ReduxState } from '../../../../types/app';

const { Content } = Layout;

const normalizeProfileHost = (profileHost?: string) => {
  const host = profileHost?.trim();

  if (!host) return null;

  return /^https?:\/\//i.test(host) ? host : `https://${host}`;
};

const getDepositIframePath = (pathname: string) => {
  const suffix = pathname.startsWith(DEPOSIT_PATH)
    ? pathname.slice(DEPOSIT_PATH.length)
    : '';

  return `${PROFILE_DEPOSIT_PATH}${suffix}`;
};

const hideIframeHorizontalOverflow = (
  event: React.SyntheticEvent<HTMLIFrameElement>
) => {
  const doc = event.currentTarget.contentDocument;

  if (!doc?.documentElement) return;

  doc.documentElement.style.overflowX = 'hidden';

  if (doc.body) {
    doc.body.style.overflowX = 'hidden';
  }
};

const DepositPage = () => {
  const { theme } = useTheme();
  const location = useLocation();
  // const navigate = useNavigate();

  const intl = useIntl();
  const profileHost = useSelector(
    (state: ReduxState) => state.Data.config?.profileHost
  );

  const depositIframeUrl = useMemo(() => {
    const normalizedProfileHost = normalizeProfileHost(profileHost);

    if (!normalizedProfileHost) return null;

    const url = new URL(
      getDepositIframePath(location.pathname),
      normalizedProfileHost
    );

    new URLSearchParams(location.search).forEach((value, key) => {
      url.searchParams.set(key, value);
    });

    setIframeQuery(url, intl.locale, theme);

    return url.toString();
  }, [intl.locale, location.pathname, location.search, profileHost, theme]);

  // const handleClose = () => {
  //   if (window.history.length > 1) {
  //     navigate(-1);
  //     return;
  //   }

  //   navigate(MY_FILES_PATH);
  // };

  return (
    <Layout className="deposit-page">
      <Helmet title={intl.formatMessage({ id: 'files.header.balance' })} />

      <CabinetHeader />

      <Content className="deposit-page__content">
        {/* <button
          type="button"
          className="deposit-page__close"
          aria-label={intl.formatMessage({ id: 'deposit.close' })}
          onClick={handleClose}
        /> */}
        <iframe
          className="deposit-page__iframe"
          src={depositIframeUrl || undefined}
          title={intl.formatMessage({ id: 'files.header.balance' })}
          onLoad={hideIframeHorizontalOverflow}
        />
      </Content>
    </Layout>
  );
};

export default DepositPage;
